import ReactTypingEffect from "react-typing-effect";

const HeroSection = () => {
  return (
    <div className="relative ">
      <div className="flex flex-col items-center h-[80vh] px-4 md:px-20 ">
        <div className="flex flex-col justify-center items-center flex-1 max-w-7xl">
          <ReactTypingEffect
            text={[
              "Qualität bauen, Exzellenz erhalten.",
              "Raum schaffen, Werte bewahren.",
              "Strukturen errichten, Sauberkeit garantieren.",
              "Baukunst vollenden, Räume pflegen.",
              "Nachhaltig bauen, makellos instand halten.",
            ]}
            speed={"50"}
            eraseSpeed={"50"}
            eraseDelay={"2000"}
            typingDelay={"100"}
            cursorRenderer={(cursor) => (
              <h1 className="text-[30px] md:text-[60px] text-center mb-5 text-[#375ede]">
                {cursor}
              </h1>
            )}
            displayTextRenderer={(text, i) => {
              return (
                <h1>
                  {text.split("").map((char, i) => {
                    const key = `${i}`;
                    return (
                      <span
                        key={key}
                        className="text-[30px] md:text-[60px] text-center mb-5"
                      >
                        {char}
                      </span>
                    );
                  })}
                </h1>
              );
            }}
          />

          <a href="tel:+491708862172">
            <div className="cursor-pointer flex justify-center items-center border-[2px] border-white rounded-2xl p-4  bg-[#375ede] font-semibold mt-5 text-white">
              Ruf uns jetzt an
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
